module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2MDkuMzA3IiBoZWlnaHQ9IjMiIHZpZXdCb3g9IjAgMCA2MDkuMzA3IDMiPjxkZWZzPjxzdHlsZT4uYXtmaWxsOm5vbmU7c3Ryb2tlOiNmZjc2ODk7c3Ryb2tlLWxpbmVjYXA6cm91bmQ7c3Ryb2tlLXdpZHRoOjNweDtzdHJva2UtZGFzaGFycmF5OjQgNzt9PC9zdHlsZT48L2RlZnM+PGxpbmUgY2xhc3M9ImEiIHgyPSI2MDYuMzA3IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxLjUgMS41KSIvPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/recruit_2021/young_pink_line.svg
// module id = DWMy
// module chunks = 0